

































































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import BudgetExpense from "@/models/porposal/budgetExpense.model";
@Component
export default class BudgetExpenseAdd extends GenericAdd<BudgetExpense> {
  constructor() {
    super();
    this.controller = "BudgetExpense";
    this.model = new BudgetExpense();
  }
}
